var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Modal',{attrs:{"width":600,"title":_vm.title,"transfer":"","footer-hide":true},model:{value:(_vm.modalShow),callback:function ($$v) {_vm.modalShow=$$v},expression:"modalShow"}},[_c('div',{ref:"modalEchart",staticClass:"pi-home-modal-echart"})])
}
var staticRenderFns = []

export { render, staticRenderFns }